import { render, staticRenderFns } from "./ViewPlace.vue?vue&type=template&id=62aeae7a"
import script from "./ViewPlace.vue?vue&type=script&lang=js"
export * from "./ViewPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports